import { render, staticRenderFns } from "./chat-client.vue?vue&type=template&id=0dc1e887&scoped=true"
import script from "./chat-client.vue?vue&type=script&lang=js"
export * from "./chat-client.vue?vue&type=script&lang=js"
import style0 from "./chat-client.vue?vue&type=style&index=0&id=0dc1e887&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc1e887",
  null
  
)

export default component.exports